import { Component, OnInit, ChangeDetectorRef, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from './services/user.service';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { SubtitleService } from './services/subtitle.service';
import { MessageService } from './services/message.service';
import { Spinkit, NgHttpLoaderComponent } from 'ng-http-loader';

import { ButtonModule } from 'primeng/button';
import { FlashMessageComponent } from './components/parts/flash-message/flash-message.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, RouterOutlet, ButtonModule, NgHttpLoaderComponent, FlashMessageComponent],
})
export class AppComponent implements OnInit {
  public spinkit = Spinkit;
  public menus: any;
  public subtitle: string;
  public loading = true;

  constructor(
    private router: Router,
    public userService: UserService,
    public subtitleService: SubtitleService,
    private message: MessageService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
  ) {}

  ngOnInit() {
    this.initMenu();
    this.initRoute();
    this.subtitleService.subtitleState.subscribe((title) => {
      this.subtitle = title;
    });

    this.message.loadingState.subscribe((loading) => {
      this.zone.run(() => {
        this.loading = loading;
        this.cdr.detectChanges();
      });
    });
  }

  initMenu() {
    this.menus = [
      {
        label: 'Amazon通知',
        routerLink: ['/'],
      },
    ];
  }

  goRegister() {
    this.router.navigate(['/register']);
  }

  goLogin() {
    this.router.navigate(['/login']);
  }

  initRoute() {
    // nothing todo
  }

  logout() {
    this.userService.logout(
      (resp) => {
        this.router.navigate(['/login']);
        this.message.setFlashMessageWithClear('success', '成功', 'ログアウトしました');
      },
      (err) => {
        this.router.navigate(['/login']);
        this.message.setFlashMessageWithClear(
          'error',
          'エラー',
          'エラーが発生したため、強制ログアウトしました。ご利用になる場合は再度ログインしてください。',
        );
      },
    );
  }
}
